<template>
    <div
        :data-locale="locale"
        :data-template-id="templateId"
        :data-businessunit-id="businessunitId"
        :data-style-height="height"
        :data-style-width="width"
        :data-theme="theme"
        :data-stars="stars"
        class="trustpilot-widget"
    >
        <a href="https://uk.trustpilot.com/review/yourparkingspace.co.uk" target="_blank" rel="noopener">
            <slot>
                Trustpilot
            </slot>
        </a>
    </div>
</template>

<script>
    import { loadScript } from '../helpers';

    export default {
        name: 'trustpilot-widget',

        props: {
            theme: {
                type: String,
                default() {
                    return 'dark';
                },
            },
            locale: {
                type: String,
                default() {
                    return 'en-GB';
                },
            },
            templateId: {
                type: String,
                default() {
                    return '53aa8807dec7e10d38f59f32';
                },
            },
            businessunitId: {
                type: String,
                default() {
                    return '582c6fe30000ff0005979964';
                },
            },
            height: {
                type: String,
                default() {
                    return '150px';
                },
            },
            width: {
                type: String,
                default() {
                    return '100%';
                },
            },
            stars: {
                type: String,
                default() {
                    return '';
                },
            },
            schemaType: {
                type: String,
                default() {
                    return '';
                },
            },
        },

        mounted() {
            this.$nextTick(this.loadWidget);
        },

        methods: {
            /**
             * Load the trustpilot script and check when it's been loaded
             */
            loadTrustPilotScript() {
                return loadScript({
                    name: 'trustpilot-widget',
                    src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
                    when() {
                        return window.Trustpilot !== undefined;
                    },
                    return() {
                        return window.Trustpilot;
                    },
                });
            },

            /**
             * Explicitly load the widget as it doesn't exist on page load
             */
            loadWidget() {
                this.loadTrustPilotScript().then((Trustpilot) => {
                    Trustpilot.loadFromElement(this.$el);
                });
            },
        },
    };
</script>

<style>
    .trustpilot-widget iframe {
        margin: 0 auto;
        width: 100%;
    }
</style>
